var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarnReport = function SvgWarnReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 96 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M480 775q14 0 24.5-10.5T515 740t-10.5-24.5T480 705t-24.5 10.5T445 740t10.5 24.5T480 775m-30-144h60V368h-60zM330 936 120 726V426l210-210h300l210 210v300L630 936zm25-60h250l175-175V451L605 276H355L180 451v250zm125-300"
  })));
};
export default SvgWarnReport;